import { IconButton, IconButtonProps, styled, Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/sharp-solid-svg-icons";
import { ComponentType, FC } from "react";
import { faDownload, faEye, faListUl, faPenToSquare } from "@fortawesome/sharp-light-svg-icons";

type StandardActionButtonIcon = "view" | "edit" | "download" | "list";

export interface ActionButtonProps {
  tooltip: string;
  label: string;
  onClick: () => void;
  icon: StandardActionButtonIcon | IconDefinition;
}

const ActionIconButton = styled(
  IconButton,
  {}
)<IconButtonProps>(({ theme }) => ({
  color: theme.palette.text.primary,
  width: "40px",
  height: "36px",
  borderRadius: "2px",
  border: "1px solid",
  borderColor: "primary",
  "&:hover": {
    boxShadow: "none",
  },
  "&:focus": {
    outlineStyle: "solid",
    outlineWidth: "2px",
  },
})) as ComponentType<IconButtonProps>;

export const ActionButton: FC<ActionButtonProps> = ({ tooltip, onClick, label, icon }) => {
  return (
    <Tooltip title={tooltip} placement="top" arrow>
      <ActionIconButton focusRipple={false} onClick={onClick} size="small" aria-label={label}>
        <FontAwesomeIcon icon={getIconElement(icon)} />
      </ActionIconButton>
    </Tooltip>
  );
};

function getIconElement(icon: StandardActionButtonIcon | IconDefinition): IconDefinition {
  switch (icon) {
    case "list":
      return faListUl;
    case "edit":
      return faPenToSquare;
    case "view":
      return faEye;
    case "download":
      return faDownload;
    default:
      return icon;
  }
}
